import React from 'react'
import styles from './group-entry.styles'
import injectSheet from 'react-jss'
import { Cell } from 'pobble-components/dist/table'
import Checkbox from 'pobble-components/dist/form-elements/form-checkbox'
import EyeIcon from 'react-icons/lib/fa/eye'
import EyeSlashIcon from 'react-icons/lib/fa/eye-slash'
import Tooltip from 'pobble-components/dist/tooltip'
import UserName from 'pobble-components/dist/user-name'
import ContextMenu from './context-menu/context-menu.container'
import Spinner from 'pobble-components/dist/spinner'
import classNames from 'classnames'

const PupilEntry = ({
  classes,
  selected,
  title,
  access,
  students,
  onSelect,
  worksPublished,
  recieved,
  out,
  views,
  onClick,
  id,
  pending,
  mis
}) => (
  <tr className={classNames({ [classes.pendingRow]: pending })}>
    <Cell className={classes.center}>
      <Checkbox checked={selected} onChange={onSelect} />
    </Cell>
    <Cell>
      <span className={classes.groupWrapper} onClick={onClick}>
        <UserName>{title}</UserName>
        {mis && <span className={classes.misLabel}>MIS</span>}
      </span>
    </Cell>
    <Cell className={classes.center}>
      {access ? (
        <Tooltip content="Group is listed on the school page">
          <EyeIcon />
        </Tooltip>
      ) : (
        <Tooltip content="The team can see this group, but it not listed in the school page">
          <EyeSlashIcon />
        </Tooltip>
      )}
    </Cell>
    <Cell className={classes.center}>{students}</Cell>
    <Cell className={classes.center}>{worksPublished}</Cell>
    <Cell className={classes.center}>{recieved}</Cell>
    <Cell className={classes.center}>{out}</Cell>
    <Cell className={classes.center}>{views}</Cell>
    <Cell className={classes.right}>
      {pending && <Spinner className={classes.spinner} />}
      {!pending && <ContextMenu id={id} />}
    </Cell>
  </tr>
)

export default injectSheet(styles)(PupilEntry)
